<template>
  <header
    class="pt-nav relative flex h-[80vh] min-h-[22rem] flex-col-reverse lg:block lg:h-[80vh] xl:h-[67vh]"
    :class="[
      data.is_white
        ? 'bg-white text-black'
        : 'text-white bg-blue-500 green:bg-green-500 pink:bg-pink-500',
      { 'overflow-hidden': !data.is_white },
    ]"
  >
    <Container
      class="relative z-10 flex flex-col pt-12 pb-14 lg:h-full lg:justify-end lg:pb-20 xl:px-16"
    >
      <p
        v-if="parentPage && parentPage.parent"
        class="mb-4 text-3xs font-semibold uppercase lg:text-2xs"
      >
        <!-- eslint-disable-next-line -->
         <span v-if="parentPage.parent.url !== '/'">{{ parentPage.parent.title }} – </span>{{ parentPage.title }}
      </p>
      <h1
        class="hyphens-auto max-w-4xl text-xl font-medium md:text-4xl lg:text-5xl xl:text-7xl"
        v-html="data.heading"
      />
    </Container>

    <ClientOnly v-if="data.file && data.file.extension === 'json'">
      <Vue3Lottie
        :animation-link="data.file.url"
        :renderer-settings="{
          preserveAspectRatio: 'xMinYMax slice',
        }"
        class="lottie-small pointer-events-none -right-14 -bottom-20 -mr-16 -mb-12 max-w-[100vw] flex-1 overflow-hidden xs:flex xs:justify-end md:top-[7.25rem] md:mr-0 lg:absolute lg:bottom-[15vw] lg:block xl:bottom-0"
      />
    </ClientOnly>

    <Floater :link="data.link" :link-text="data.link_text" />
  </header>
</template>

<script setup>
defineProps({
  data: {
    type: Object,
    required: true,
  },
  parentPage: { type: Object, default: null },
})
</script>

<style>
.lottie-small svg {
  height: 100% !important;

  @screen xs {
    width: auto !important;
  }
  @screen lg {
    width: 100% !important;
  }
}
</style>
